import { IconLogout } from '@tabler/icons-react';

import { Skeleton, Typography } from '@mui/material';

import { first } from '@helpers/data';

import { authLogout } from '@actions/auth/auth-logout';
import { accountGetMe } from '@selectors/account';

import { useTypedDispatch, useTypedSelector } from '@hooks/store';

import { UserTimezone } from '@widgets/time/user-timezone';

import {
  MainLayoutHeaderProfileAvatarStyled,
  MainLayoutHeaderProfileButtonExitStyled,
  MainLayoutHeaderProfileButtonTextSx,
  MainLayoutHeaderProfileUserBoxStyled,
  MainLayoutHeaderProfileUserDataStyled,
  MainLayoutHeaderProfileUserNameTypographyStyled,
} from './styled';

export const MainLayoutHeaderProfile: React.FC = () => {
  const dispatch = useTypedDispatch();

  const account = useTypedSelector(accountGetMe);

  const handleLogout = () => {
    dispatch(authLogout());
  };

  return (
    <>
      <MainLayoutHeaderProfileUserBoxStyled>
        <UserTimezone />

        <MainLayoutHeaderProfileAvatarStyled
          variant={'square'} //
          color="inherit"
        >
          {first(account.name)}
        </MainLayoutHeaderProfileAvatarStyled>

        <MainLayoutHeaderProfileUserDataStyled>
          <MainLayoutHeaderProfileUserNameTypographyStyled
            variant={'subtitle1'}
          >
            {account.name === undefined ? (
              <Skeleton width={60} />
            ) : (
              account.name
            )}
          </MainLayoutHeaderProfileUserNameTypographyStyled>

          <Typography variant={'subtitle2'}>
            {account.email === undefined ? (
              <Skeleton width={120} />
            ) : (
              account.email
            )}
          </Typography>
        </MainLayoutHeaderProfileUserDataStyled>
      </MainLayoutHeaderProfileUserBoxStyled>

      <MainLayoutHeaderProfileButtonExitStyled onClick={handleLogout}>
        <IconLogout
          stroke={1.5} //
          width={21}
        />

        <Typography
          sx={MainLayoutHeaderProfileButtonTextSx} //
          variant="body2"
        >
          Выйти
        </Typography>
      </MainLayoutHeaderProfileButtonExitStyled>
    </>
  );
};
